import { uniq } from 'ramda';
import { useBetslipLsStore } from './store';

export const actionsCreator = ({ setState }) => ({
  SET_BASKET_NUMBER: (number) => setState({ basketNumber: number }),

  UPDATE_NON_EMPTY_BASKETS: (isNotEmpty) =>
    setState(({ basketNumber, nonEmptyBaskets }) => ({
      nonEmptyBaskets: isNotEmpty
        ? uniq([...nonEmptyBaskets, basketNumber])
        : nonEmptyBaskets.filter((v) => v !== basketNumber)
    }))
});

export const betslipLsStoreActions = actionsCreator(useBetslipLsStore);
